/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserActivityWithRelations } from '../../models/user-activity-with-relations';

export interface InventoryGetActivities$Params {
  inventoryId: string;
  limit: number;
}

export function inventoryGetActivities(http: HttpClient, rootUrl: string, params: InventoryGetActivities$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserActivityWithRelations>>> {
  const rb = new RequestBuilder(rootUrl, inventoryGetActivities.PATH, 'get');
  if (params) {
    rb.query('inventoryId', params.inventoryId, {});
    rb.query('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UserActivityWithRelations>>;
    })
  );
}

inventoryGetActivities.PATH = '/inventory/activities';
